import styled from 'styled-components';
import { MarkerIcon as MarkerIconComponent } from './markerIcon';
import { themeSize } from '../../../theme/getters';
import { media } from '../../../theme/media';

export const Container = styled.div`
  text-align: left;
  width: 100%;
  position: sticky;
  top: ${themeSize('header')}px;
  height: calc(100vh - ${themeSize('header')}px - ${themeSize('contentPadding')}px * 2);

  ${media.tablet`
     height: calc(100vh - ${themeSize('header')}px);
  `}

  ${media.desktopFull`
    top: calc(${themeSize('header')}px + ${themeSize('contentPadding')}px);
    height: calc(100vh - ${themeSize('header')}px - ${themeSize('contentPadding')}px * 2);
  `}
`;

export const MapWrapper = styled.div`
  width: 100%;

  > * {
    //needs to override mapbox html attributes
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
`;

export const MarkerIcon = styled(MarkerIconComponent)`
  pointer-events: none;
  transform: translate(-50%, -100%);
`;
